import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import Modal from "../../../../../components/Modal";
import Content from "../../Notifications/Content";
import { usePreferenceMutation } from "../../../Configuration/api/usePreferenceMutation";
import { preferenceQueryKeys } from "../../../Configuration/api/usePreferenceQuery";
import useApi from "../../../../../utils/api";
import { useUser } from "../../../../../utils/hooks/user";
import "./style.scss";

const formatPreferences = (data) => {
    return (data || []).reduce((total, item) => ({
        ...total,
        [item.preferenceKey]: item.config,
    }), {});
};

const NotificationModal = ({ isOpen, close, values }) => {
    const user = useUser();
    const { authGet } = useApi();

    const { data: rawData, isLoading: loading } = useQuery({
        queryKey: preferenceQueryKeys.company(values?.id),
        queryFn: () => authGet(`/preferencies/company/${values?.id}`),
        enabled: isOpen && !!values?.id,
    });

    const data = formatPreferences(rawData?.result);

    const { mutateAsync: submit, isPending: submitting } = usePreferenceMutation(
        "company",
        "notifications",
        values?.id,
    );

    const onFinish = useCallback(async (config, onSuccess) => {
        try {
            const response = await submit(config);
            onSuccess?.(response);
            close();
        } catch (error) {
            // error toast handled by usePreferenceMutation
        }
    }, [submit, close]);

    return (
        <Modal
            className="company-notification-modal"
            isOpen={isOpen}
            toggle={close}
            centered size="lg"
        >
            <Content
                values={data}
                loading={loading}
                submitting={submitting}
                submit={onFinish}
                page={values?.isMasterCompany ? "mainCompany" : "company"}
                user={user}
                isSelf={false}
            />
        </Modal>
    );
};

export default NotificationModal;
